import { Component, Input } from '@angular/core';

@Component({
  selector: 'client-logo-app',
  templateUrl: './client-logo.component.html',
  styleUrls: ['./client-logo.component.scss']
})
export class ClientLogoComponent {
  @Input() orangeLogoSize: any;
  @Input() dsgLogoSize: any;
  @Input() descriptionSize: any;
  constructor(
  ) { }

  followToDataSystem() {
    window.location.href = 'https://datasystem.pl';
  }
}
